module.exports = __webpack_public_path__ + "static/media/GDOCS_SOW_Guide.8b341e4f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GDOCS_SOW_Guide.pdf
// module id = 107
// module chunks = 4